<template>
    <span>
        <span class="filters-list__item-name" :class="{'filters-list__item-name--active' : isFacetCollapsed}" @click="isFacetCollapsed = !isFacetCollapsed">
            <span v-html="displayName"></span><i class="fa fa-caret-up"></i>
        </span>
        <ul class="filters-list__nested-list" :class="{'filters-list__nested-list--collapsed' : isFacetCollapsed}">
            <li v-for="facetValue in facetValues"
                class="filters-list__nested-item">
                 <span class="custom-checkbox custom-checkbox-wrapper">
                    <input class="custom-checkbox__input" type="checkbox" @change="$emit('updateCheckbox')" v-model="model[facetValue.value]"
                           :id="facetValue.value" />
                    <span class="custom-checkbox__checkmark"></span>
                </span>
                <label class="custom-control-label" :for="facetValue.value">{{facetValue.label}} ({{facetValue.count}})</label>
            </li>
            <span v-if="facetValues.length === 0">
                No options available.
            </span>
        </ul>
    </span>
</template>

<script>
    export default {
        name: "Checkbox",
        props: ['facetName', 'facetValues', 'displayName', 'model'],
        data () {
            return {
                isFacetCollapsed : true,
            }
        }

    }
</script>

<style scoped>

</style>